

class SensorService {
    async GetTemperature() {
        var payload =
            [
                "water-sensor-brygge",
                "water-sensor-båt-brygge"
            ]

        const response = await fetch(`https://iot-api.oslofjord.com/api/water-sensor/average`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(payload)
        }
        )
        var data = await response.json();
        return data;
    }
}

const sensorService = new SensorService();
export default sensorService